<template>
    <div class="container h-100">
      <div class="d-flex justify-content-center h-100">
        <div class="user_card">
          <div class="d-flex justify-content-center">
            <div class="brand_logo_container">
              <img
                src="images/logo.jpg"
                class="brand_logo"
                alt="Logo"
              />
            </div>
          </div> 
          <h5 style="color:white;" class="mt-5 d-flex justify-content-center">  Change Password</h5>
          <div class="d-flex justify-content-center">
            <form class="login-form">
              <div class="input-group mb-2">
                <div class="input-group-append">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input type="text" v-if="showPassword1" name="" class="form-control input_pass" @keyup="validatePass" v-model="password" placeholder="Enter your new password"/>
                <input type="password" v-else name="" class="form-control input_pass" @keyup="validatePass" v-model="password" placeholder="Enter your new password"/>
                <i class="fas" @click="toggleShow" :class="{ 'fa-eye': showPassword1, 'fa-eye-slash' : !showPassword1 }"></i>
              </div>
            <div v-if="p_error" class="alertError">{{ p_error }}</div>
              <div class="input-group mb-2">
                <div class="input-group-append">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input type="text" v-if="showPassword2" name="" class="form-control input_pass" @keyup="validateConfirmPass" v-model="confirmPassword" placeholder="Re-enter Password"/>
                <input type="password" v-else name="" class="form-control input_pass" @keyup="validateConfirmPass" v-model="confirmPassword" placeholder="Re-enter Password"/>
                <i class="fas" @click="hideshow" :class="{ 'fa-eye': showPassword2, 'fa-eye-slash' : !showPassword2 }"></i>
              </div>
            <div v-if="pc_error" class="alertError">{{ pc_error }}</div>
              <div class="d-flex justify-content-center  login_container">
                <DoubleBounce  v-if="showLoader"></DoubleBounce>
                <button type="button" v-else v-on:click="reset" @click="toast" name="button" class="btn login_btn">
                  Save
                </button>
              </div>  
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {DoubleBounce} from 'vue-loading-spinner'
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import { base_url } from "../../config";
  import axios from "../../services/customAxios";
  export default defineComponent({
    name:'Login',
  components: { DoubleBounce },
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data() {
      return {
        id:localStorage.getItem('ForgotId'),
        password: "",
        confirmPassword: "",
        base_url: base_url,
        p_error:"",
        pc_error:"",
        showLoader:false,
        showPassword1: false,
        showPassword2: false,
      };
    },
    methods:{
      toggleShow() {
      this.showPassword1 = !this.showPassword1
    },
    hideshow(){
      this.showPassword2= !this.showPassword2
    },
        async reset(){
            try{
              this.showLoader = true
            let response = await axios.post(`${base_url}/reset_password`, {
                id:this.id,
                password: this.password,
                confirmPassword: this.confirmPassword,
            });
            localStorage.clear("ForgotId");
            let result = response.data.result;
            console.log("check result==>", result);
            createToast({title: "Success", description: response.data.message},{type: "success"})
            this.$router.push({ name: "Login" });
            }
            catch(error){
              this.showLoader = false
            createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
            }
        },
        validatePass(){
            if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.password)) {
                this.p_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
            }else{
                this.p_error = '';
            }
        },
        validateConfirmPass(){
            if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.confirmPassword)) {
                this.pc_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
            }else{
                this.pc_error = '';
            }
        },
    },
  });
  </script>
  
  <style  scoped>
  .white{
    color: white;
  }
  .user_card{
    height: 490px;
  }
  </style>
  <style scoped>
  i.fas.fa-eye-slash,
  i.fas.fa-eye {
     position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #3a494b;
      right: 10px;
      z-index:99
  }
  </style>